module.exports = __webpack_public_path__ + "img/christian_fritz.e492788f.png";